export default __webpack_public_path__ + "static/media/loading.7f2e9654.gif";